import { Card, CardBody, CardTitle } from "reactstrap";

import Loading from "../../loader/loader";
import React from "react";
import moment from "moment";

const AppRegistrationDetails = ({
  registrationAppDetails,
  verificationLoading,
}) => {
  var first =
    registrationAppDetails &&
    registrationAppDetails.cardNumber &&
    registrationAppDetails.cardNumber.toString().substring(0, 6);
  var str1 =
    registrationAppDetails &&
    registrationAppDetails.cardNumber &&
    registrationAppDetails.cardNumber.toString().substring(6, 12);
  var second = str1 && str1.replace(str1, "******");
  var third =
    registrationAppDetails &&
    registrationAppDetails.cardNumber &&
    registrationAppDetails.cardNumber.toString().substring(12, 16);

  return (
    <Card>
      <CardBody style={{ paddingTop: 20, paddingBottom: 20 }}>
        <CardTitle
          tag="h1"
          className="user-verification-header"
        >
          App Registration Details
        </CardTitle>
        {verificationLoading ? (
          <div
            style={{
              minHeight: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loading />
          </div>
        ) : (
          <>
            <div className="mt-1 row">
              <label className="form-control-label col-lg-5 col-md-5">
                Registration Date
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label className="col-lg-6 col-md-6 rem-pad">
                {moment(registrationAppDetails.registrationDate).format(
                  "DD-MM-YY"
                ) !== "Invalid date"
                  ? moment(registrationAppDetails.registrationDate).format(
                    "DD-MM-YY"
                  )
                  : null || null}
              </label>
            </div>

            <div className="mt-1 row">
              <label className="form-control-label col-lg-5 col-md-5">
                Card Number
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label className="col-lg-6 col-md-6 rem-pad">
                {first}
                {second}
                {third}
              </label>
            </div>

            <div className="mt-1 row">
              <label className="form-control-label col-lg-5 col-md-5">
                Mobile Number
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label className="col-lg-6 col-md-6 rem-pad">
                {registrationAppDetails.phoneNumber}
              </label>
            </div>

            <div className="mt-1 row">
              <label className="form-control-label col-lg-5 col-md-5">
                Email ID
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label className="col-lg-6 col-md-6 rem-pad">
                {registrationAppDetails.email
                  ? registrationAppDetails.email
                  : "N/A"}
              </label>
            </div>

            {registrationAppDetails.kycServiceRemarks && (
              <div className="mt-1 row">
                <label className="form-control-label col-lg-5 col-md-5">
                  KYC remarks
                </label>
                <label className="col-lg-0.5 col-md-0.5">:</label>
                <label className="col-lg-6 col-md-6 rem-pad">
                  {registrationAppDetails.kycServiceRemarks}
                </label>
              </div>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default AppRegistrationDetails;
